import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  list_vendor_incidents,
  raise_incident,
  resolve_incident,
  list_owner_incidents,
  acknowledge_incident,
  type RaiseIncidentInput,
} from './api';

const vendor_key = (booking_id: string) => ['vendor-incidents', booking_id] as const;
const owner_key = (booking_id: string) => ['owner-incidents', booking_id] as const;

// ---- Vendor (walker) ----
export function use_vendor_incidents(booking_id: string, enabled = true) {
  return useQuery({ queryKey: vendor_key(booking_id), queryFn: () => list_vendor_incidents(booking_id), enabled });
}

export function use_raise_incident(booking_id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: RaiseIncidentInput) => raise_incident(booking_id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: vendor_key(booking_id) });
      qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
    },
  });
}

export function use_resolve_incident(booking_id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ incident_id, resolution_note }: { incident_id: string; resolution_note?: string }) =>
      resolve_incident(booking_id, incident_id, resolution_note),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: vendor_key(booking_id) });
      qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
    },
  });
}

// ---- Owner ----
export function use_owner_incidents(booking_id: string, enabled = true) {
  return useQuery({ queryKey: owner_key(booking_id), queryFn: () => list_owner_incidents(booking_id), enabled });
}

export function use_acknowledge_incident(booking_id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (incident_id: string) => acknowledge_incident(booking_id, incident_id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: owner_key(booking_id) });
      qc.invalidateQueries({ queryKey: ['my-bookings'] });
    },
  });
}
